import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class OrderResource extends AuthenticatedResource {
  static urlRoot = '/admin/orders'

  readonly id: number | undefined = undefined;
  
  pk() {
    return this.id?.toString();
  }
}